<template>
  <div>
    <table class="tableList" border="1">
        <tr>
           
            <th class="cehckbox" width="30"><div><input id="checkAll"  @click="handleCheckAll" type="checkbox"></div></th>
            <th><div>名次</div></th>
            <th><div>姓名</div></th>
            <th><div>单位</div></th>
            
            <th v-if="tableListItem.length"  class="thActive"  >
                <div  class="type_div">
                    <ul class="clearfix">
                        <li v-for="(arr,index) in tableListItem" :key="index" class="float-l">
                            {{arr}}
                        </li>
                    </ul>
                </div>
            </th>
            <th><div>成绩</div></th>
            <th v-if="!allNow"><div>得分</div></th>
            <th><div>审核状态</div></th>
            <th><div>操作</div></th>
            
        </tr>
        <tr  v-for="(itme,index) in tableList" :key="index">
            <td  class="cehckbox">
                <div>
                   <input name="verify" @click="checkedData(itme,index)" type="checkbox">
                </div>
            </td>
            <td  width="80" ><div class="text">{{itme.splace===0?'':itme.splace}}</div></td>
            <td>
                <div class="text">
                    {{itme.familyNameCHN}}{{itme.givenNameCHN}}
                </div> 
            </td>
            <td><div class="text">{{itme.unitNameCHN}}</div></td>
            <td   v-if="tableListItem.length" class="thActive">
                 <div  class="type_div">
                    <ul class="clearfix">
                        <li  v-for="(arr,index) in itme.details" :key="index" class="float-l">
                            {{arr.roundState}} 
                            <div v-if="(arr.windSpeed<10000 && arr.windSpeed>-10000)&&(wind)&&(getGameNames.gameType==2||getGameNames.gameType==3)">({{$PlugIn.speeds(arr.windSpeed/100)}})</div>
                        </li>
                    </ul>
                </div> 
            </td>
            <td><div class="text">{{itme.showResult}}<div v-if="itme.sporterState== -1||itme.sporterState == -9||itme.sporterState == -13">{{getsporterState(itme.sporterState)}}</div> </div></td>
            <td v-if="!allNow"><div class="text">{{itme.score}}</div></td>
            <td><div class="text">{{itme.auditState===1?'已审核':itme.auditState===-1?'审核未通过':'未审核'}}</div></td>
            <td width="162">
                <div  class="text czBut">
                    <span v-if="getUnitID(itme) &&  getGameNames.gameState===1 || getGameNames.gameState===2 ||  !getGameNames.gameState">
                        <Button v-if="!itme.auditState && getGameNames.gameState!==2 ||  !getGameNames.gameState" type="info" size="small"   @click="heightUp(itme,false)">编辑</Button>
                        <Button v-if="!itme.auditState" class="delData" type="error" size="small"   @click="trackDel(itme,1)">删除</Button>
                        <Button v-if="!itme.auditState && authorities" class="delData" type="success" size="small"   @click="trackDel(itme,2)">审核</Button>
                        <Button v-if="!itme.auditState && authorities" class="delData" type="error" size="small"   @click="trackDel(itme,4)">不通过</Button>
                        <Button v-else-if="itme.auditState && authorities" class="delData" type="error" size="small"   @click="trackDel(itme,3)">取消审核</Button>
                        <Button v-if="!itme.auditState && isImg(itme.imageUrl)" class="delData" type="info" size="small"   @click="domFile(itme.imageUrl)">下载</Button>
                        
                    </span>
                   
                    <Button  size="small"   @click="heightUp(itme,true)">详情</Button>
                </div>
                
            </td>
        </tr>
        <tr  v-if="tableList.length==0" >
            <td class="noData" colspan="8">暂时没有数据...</td>
        </tr>
    </table>
    <audit-reason v-if="reason.reasonModel" @reasonFormSubmit="reasonFormSubmitF" :reason="reason"></audit-reason>
    <iframe :src="fileUrl" style="overflow:hidden;height:0px;width:0;" frameborder="0"></iframe>
  </div>
</template>

<script>
import auditReason from '@/public/auditReason'
export default { 
 
  /*
    allProp判断如果是全能的选手就不需要名次字段 
    group判断是否为综合成绩
    childTitle传给查看运动员项目的标题
  */
  props: ['allProp','resultData','excleallProp','event','wind'],
  components:{
      auditReason
  },
  data () {
    return {
        fileUrl:'',
        reason:{
            reasonModel:false,
        },
        copyResultData:{},
        checkAll:false,
        checkArr:[],
        tableHead: [
            {
                title: '名次',
            },
           
            {
                title: '姓名',
            },
            {
                title: '单位',
            },
            {
                title: [],
            },
            {
                title: '成绩',
            },
            {
                title:'审核状态'
            }
        ],
        excletableHead: [
            {
                title: '名次',
            },
            {
                title: '姓名',
            },
            {
                title: '单位',
            },
            {
                title: '成绩',
            },
            {
                title:'审核状态'
            }
        ],
    
    }
  },
  computed: {
    authorities()
    {
      return JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin || JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
    tableList()//返回成绩列表数据
    {
        if(!this.resultData.data)
        {
            return [];
        }else{
            return this.resultData.data;
        }
    },
    tableListItem()//返回成绩列表数据
    {
     
        if(!this.resultData.items)
        {
            return [];
        }else{
            return this.resultData.items;
        }
    },
    allNow()
    {
        if(this.allProp==2)
        {
            return false;
        }else{
            return true;
        }
    },
    getGameNames()
    {
      return this.$store.state.unitAllData.gameName
    },
    
   
  },
  methods: {
    isImg(url)
    {
        if(url)
        {
            if(url.indexOf('.jpg')!=-1||url.indexOf('.JPG')!=-1||url.indexOf('.PNG')!=-1||url.indexOf('.png')!=-1)
            {
               return false;
            }else{
                return true;
            }
        }else{
            return false; 
        }
    },
    domFile(url)
    {
        let time =new Date().getTime();
        this.fileUrl = `${this.$imgUrl}/api/resources/respource?path=${url}&isDownload=true&time=${time}`;
    },
     getUnitID(itme)//判断是否为本单位
    {
       return localStorage.scoreEntryId==itme.scoreEntryId || JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin || JSON.parse(localStorage.authorities)==this.$PlugIn.role.entryAdmin;
    },
    trackDel(obj,type)
    {
        let str = '';
        if(type==2)
        {
            obj.types = 2;
            str = '通过审核';
        }else if(type==3)
        {   
            obj.types = 3;
            str = '取消审核';
        }else if(type==4)
        {   
            obj.types = 4;
            str = '不通过审核';
        }else{
            str = '删除';
            obj.types = 1;
        }
        
        this.copyResultData = this.$PlugIn.deepClone(obj);
        if(type!==4)
        {   
            this.$Modal.confirm({
                title: '提示',
                content: '<p>您确定要'+str+'吗？</p>',
                onOk: () => {
                    this.$emit('onDelData',this.copyResultData);
                }
            });
        }else{
            this.reason.reasonModel = true;
        }
        
    },
    reasonFormSubmitF(data)
    {
        this.copyResultData.auditUnPassReason = data ? data : '';
        this.$emit('onDelData',this.copyResultData);
        this.reason.reasonModel = false;
    },
    checkedData()
    {
        let verify = document.getElementsByName('verify');
        let checkAll = document.getElementById('checkAll');
        for(let i = 0; i<verify.length;i++)
        {
            if(!verify[i].checked)
            {
                checkAll.checked = false;
                break;
            }else{
                checkAll.checked = true;
            }
        }
    },
    handleCheckAll () {
       let verify = document.getElementsByName('verify');
       let checkAll = document.getElementById('checkAll');
       for(let i = 0; i<verify.length;i++)
       {
           if(checkAll.checked)
           {
               verify[i].checked = true;
           }else{
               verify[i].checked = false;
           }
           
       }
    },
    heightUp(obj,up)
    {
        this.$emit('trackUpShow',{data:obj,items:this.tableListItem,up:up});
    },
    getsporterState(state)
    {
        let str = '';
        if(state==-1)
        {
            str = 'DQ';
        }else if(state==-13)
        {
            str = 'YC';
        }else if(state==-9){
            str = 'DT';
        }
        return str;
    }
  },
  created () {
    
  },
  mounted () {
    
  }
}
</script>
<style scoped>
    .tableList{width: 100%;margin-top: 22px;text-align: center;}
    .tableList td,.tableList th{padding: 8px 4px;}
    .type_div li {
        width: 52px;
        padding: 3px 2px;
    }
    .thActive{width: 342px;}
    .cehckbox{
        text-align: center;
        
    }
    .cehckbox .ivu-checkbox-wrapper{
            margin-right: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/EventTypeHigh.vue